import { faAddressBook } from '@fortawesome/pro-regular-svg-icons'
import { FundingContact } from '../../api/fundingApi'
import { SectionCard } from './SectionCard'
import { DetailField } from './DetailField'
import { useStyles } from './ContactInformation.styles'

interface ContactInformationProps {
  contact: FundingContact | null | undefined
}

export const ContactInformation = ({ contact }: ContactInformationProps) => {
  const { classes } = useStyles()
  const c = contact ?? {}

  return (
    <SectionCard
      icon={faAddressBook}
      title="Contact information"
      collapsible
      testId="funding-detail-contact"
    >
      <div className={classes.grid}>
        <DetailField label="Job title" value={c.job_title} />
        <DetailField label="Email" value={c.email} copyValue={c.email} />
        <span className={classes.divider} />
        <DetailField label="First name" value={c.first_name} />
        <DetailField label="Last name" value={c.last_name} />
      </div>
    </SectionCard>
  )
}
